import { render, staticRenderFns } from "./EnacAtplDashboardNotificationProcedureModal.vue?vue&type=template&id=aef6130c"
import script from "./EnacAtplDashboardNotificationProcedureModal.vue?vue&type=script&lang=js"
export * from "./EnacAtplDashboardNotificationProcedureModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports